(function () {
  angular.module("akitabox.ui.components.label", []);
})();
